import Referral from "./Referral";

class UTM extends Referral {
    constructor(tag) {
        super(tag);
        this.value = JSON.parse(localStorage.getItem(this.tag)) || null;
    }

    _parseUrlParams() {
        const utm_params = {
            utm_source: null,
            utm_medium: null,
            utm_campaign: null,
            utm_content: null,
            utm_term: null,
        };

        let hasParam = false;
        for (const param in utm_params) {
            const match = location.search.match(new RegExp(`[?&]${param}=([^&]+)`));
            if (match) {
                utm_params[param] = decodeURI(match[1]);
                hasParam = true;
            }
        }

        return hasParam ? utm_params : null;
    }

    getTagFromUrl() {
        const fromUrl = this._parseUrlParams();
        return JSON.stringify(fromUrl ?? this.value);
    }

    setValue() {
        const fromUrl = this._parseUrlParams();
        if (fromUrl) {
            this.value = fromUrl;
        }
        localStorage.setItem(this.tag, JSON.stringify(this.value));
    }

    getValue() {
        const fromUrl = this._parseUrlParams();
        const data = fromUrl ?? this.value;
        return data ? JSON.stringify(data) : null;
    }
}
export default UTM;
